/* Falconclaw store-pickup prefill (2026-10-13).
   When the cart carries a store-pickup discount code, the Checkout button goes to
   Shopify's checkout permalink with the office address filled in, so the buyer is
   not asked to invent an address for a parcel that never ships. The fields stay
   editable and only fill when empty (proven on this shop, 2026-09-01). Express
   buttons (Shop Pay, Google Pay) are left alone. Any failure = plain checkout.
   The same codes carry the fc_pickup marker metafield read by the fc-pickup-gate
   Function and sit in the shipping app's PICKUP_CODES; keep the three in step. */
(function () {
  'use strict';
  var CODES = ['TEAMROOMSPECIAL', 'TULENJÄRGI'];
  var ADDRESS = {
    'checkout[shipping_address][address1]': 'Jalgpalli 1',
    'checkout[shipping_address][address2]': '316',
    'checkout[shipping_address][city]': 'Tallinn',
    'checkout[shipping_address][zip]': '11312',
    'checkout[shipping_address][country]': 'Estonia'
  };
  var busy = false;

  function prefillUrl() {
    var parts = [];
    for (var k in ADDRESS) {
      parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(ADDRESS[k]));
    }
    return '/cart/checkout?' + parts.join('&');
  }

  function hasPickupCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].applicable && CODES.indexOf(String(codes[i].code).toUpperCase()) !== -1) {
        return true;
      }
    }
    return false;
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('button[name="checkout"]') : null;
    if (!btn || busy) {
      return;
    }
    var form = btn.form;
    if (!form) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    busy = true;
    function plain() {
      busy = false;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = '';
      form.appendChild(hidden);
      form.submit();
    }
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (hasPickupCode(cart)) {
          window.location.href = prefillUrl();
        } else {
          plain();
        }
      })
      .catch(plain);
  }, true);
})();
